<template>
    <div class="main-cards card">
        <div class="card-header">
            <div class="headercard" style="display: flex; align-items: center;">							
                <img :src="require('@/assets/images/dashboard/temperatura.png')" alt="home" style="max-width: 3vh;">
                &nbsp;
                <h5 style="margin: 0%">Estação Meteorológica</h5>
            </div>
        </div>
        <div class="card-body" id="silos">
            <section class="text-center">
                <EstacaoDashboard :estacao="estacao.estacao"/>
                <table class="table table-borderless"  style="font-size: 10pt;">
                    <thead>
                        <tr>
                            <th scope="col" class="text-center"></th>
                            <th scope="col" class="text-center">Temperatura</th>
                            <th scope="col" class="text-center">Umidade</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th class="text-end">Máx <img :src="require('@/assets/images/dashboard/arrow.png')" alt="home" style="rotate: 180deg; max-width: 1vh;"></th>
                            <th class="text-center">{{ estacao.maxMin ? estacao.maxMin.temperatura.max : '0' }}°C</th>
                            <th class="text-center">{{ estacao.maxMin ? estacao.maxMin.umidade.max : '0' }}%</th>
                        </tr>
                        <tr>
                            <th class="text-end">Mín <img :src="require('@/assets/images/dashboard/arrow.png')" alt="home" style="max-width: 1vh;"></th>
                            <th class="text-center">{{ estacao.maxMin ? estacao.maxMin.temperatura.min : '0' }}°C</th>
                            <th class="text-center">{{ estacao.maxMin ? estacao.maxMin.umidade.min : '0' }}%</th>
                        </tr>
                    </tbody>
                </table>
                <small class="text-center" style="font-size: 9pt;">Informações de Hoje </small>
            </section>
        </div>
    </div>
</template>
<script>
import EstacaoDashboard from '@/components/ui/App/EstacaoDashboard.vue';

export default {
    name: 'DashboardEstacao',
    components: {
        EstacaoDashboard
    },
    props: {
        estacao: {
            type: Object,
            default: () => ({
                estacao: {},
                maxMin: {}
            })
        },
    }    
};
</script>
<style scoped>
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.card-header img {
    max-width: 3vh;
}

.card-body {
    position: relative;
    padding-top: 20px;
}

.card {
    margin-bottom: 0;
}

.main-cards{
    margin: 0.5rem;
    margin-bottom: 1rem;
}
</style>